import React from "react";
import { alertMessages } from "../../constants/app-constant";

function ErrorMessage(props) {
    const { errorType, errorFieldName, minLength, maxLength } = props;

    return (
        <>
            {errorType === 'required' && <span className='validation_error'>{errorFieldName} is required</span>}
            {errorType === 'maxLength' && <span className='validation_error'>{errorFieldName} maximum length should be {maxLength}</span>}
            {errorType === 'minLength' && <span className='validation_error'>{errorFieldName} minimum Length should be {minLength}</span>}
            {errorType === 'pattern' && <span className='validation_error'>
                {errorFieldName === 'New Password' ? alertMessages.newPassError : errorFieldName + 'is invalid'}
            </span>}
            {errorType === 'IsPasswordConfirmationMatching' && <span className='validation_error'>{errorFieldName} is should be same</span>}
            {errorType === 'IsEmailExist' && <span className='validation_error'>{errorFieldName} is already exist</span>}
            {errorType === "uniquevalue" && <span className="validation_error">The {errorFieldName} already exists.</span>}
            {errorType === "IsPasswordSameaAsOld" && <span className="validation_error"> Your {errorFieldName} cannot be the same as your previous password. Please choose a different password</span>}

        </>
    )
}

export default ErrorMessage;
